module.exports = __webpack_public_path__ + "img/product_52.e880d30.svg";